import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import FeladatCsoportEditService from 'app/admin/feladatCsoport/service/FeladatCsoportEditService';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import FejezetEditService from 'app/admin/fejezet/service/FejezetEditService';
// import UserGroupService from 'app/admin/userGroup/service/UserGroupService';

const config = {
	key: 'feladatCsoportEditForm',
	text: 'Feladat csoportok',
	textKey: 'feladatCsoport',
	service: FeladatCsoportEditService,
	icon: 'person',
	fields: [
		{
			key: 'nev',
			text: 'Név',
			textKey: 'nev',
			component: EditFormTextField,
			required: true
		},
		{
			key: 'rovid',
			text: 'Rövid név',
			textKey: 'rovid',
			component: EditFormTextField,
			required: true
		},
		{
			key: 'fejezet',
			text: 'Fejezet',
			component: EditFormSelectField,
			multiple: true,
			items: () => FejezetEditService.getFejezetSelection()
		},
		// {
		// 	key: 'userGroup',
		// 	text: 'Felhasználói csoport',
		// 	component: EditFormSelectField,
		// 	// multiple: true,
		// 	items: () => UserGroupService.getListSelection()
		// }
	]
};

function FeladatCsoportEditForm() {
	return <EditFormPage config={config} />;
}

export default FeladatCsoportEditForm;
